import { createAsyncThunk, createAction } from '@reduxjs/toolkit'
import companyPlanningRecordService from '../../../services/companyPlanningRecordService'
import { CompanyPlanningRecord } from '@leadgen/models/client'

class CompanyPlanningRecordActions {
  loadCompanyPlanningRecord = createAsyncThunk(
    'companyPlanningRecord/loadCompanyPlanningRecord',
    async (
      {
        companyPlanningRecordId,
        companyId,
      }: {
        companyPlanningRecordId: string
        companyId: string
      },
      { dispatch },
    ) => {
      const response = await companyPlanningRecordService.subscribeToCompanyPlanningRecord({
        companyId,
        companyPlanningRecordId,
        onCompanyPlanningRecordUpdated: companyPlanningRecord => {
          dispatch(this.updateCompanyPlanningRecord(companyPlanningRecord))
        },
      })
      return response
    },
  )
  updateCompanyPlanningRecord = createAction(
    'companyPlanningRecord/updateCompanyPlanningRecord',
    (companyPlanningRecord: CompanyPlanningRecord) => ({
      payload: companyPlanningRecord,
    }),
  )
}

export default new CompanyPlanningRecordActions()
